import { render } from "./q4.vue?vue&type=template&id=40a97096&scoped=true"
import script from "./q4.vue?vue&type=script&lang=js"
export * from "./q4.vue?vue&type=script&lang=js"

import "./q4.vue?vue&type=style&index=0&id=40a97096&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a97096"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40a97096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40a97096', __exports__)) {
    api.reload('40a97096', __exports__)
  }
  
  module.hot.accept("./q4.vue?vue&type=template&id=40a97096&scoped=true", () => {
    api.rerender('40a97096', render)
  })

}


export default __exports__